import urls from "./urls"

interface Route {
  name: keyof typeof urls
  params?: Record<string, unknown>
}

export default (route: Route) =>
  (urls[route.name] as { props: (r: Route) => unknown }).props(route)
